import {
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from "@coreui/react";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DeleteIcon from "../../../components/icons/DeleteIcon";
import PromptModal from "../../../components/modals/PromptModal";
import { colors } from "../../../config/theme";
import EditIcon from "../../../components/icons/EditIcon";

interface TaxiCouponsTableProps {
  specialZones: RideSpecialZone[];
  deleteSpecialZone: (id: string) => void;
  isDeleting: boolean;
}

interface TableBodyProps {
  specialZone: RideSpecialZone;
  onDelete: () => void;
}

function TableBodyRowContent({ specialZone, onDelete }: TableBodyProps) {
  return (
    <CTableRow
      style={{
        width: "100%",
        position: "relative",
      }}
    >
      <CTableDataCell className="px-3 text-sm">
        <div className="d-flex align-items-center gap-3">
          <p className="m-0">{specialZone.name}</p>
        </div>
      </CTableDataCell>
      <CTableDataCell className="px-3 text-sm">
        {specialZone.price}
      </CTableDataCell>
      <CTableDataCell className="p-3 text-sm">
        {specialZone.isActive ? "✅ Oui" : "❌ Non"}
      </CTableDataCell>
      <CTableDataCell
        className="p-3 text-sm text-wrap text-start font-monospace"
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          maxWidth: "250px",
        }}
      >
        {specialZone.description ? (
          specialZone.description
        ) : (
          <span className="text-muted"></span>
        )}
      </CTableDataCell>
      <CTableDataCell className="p-3  align-items-center justify-content-center">
        <Link to={`/taxi/special-zones/update/${specialZone.id}`}>
          <EditIcon width="18" height="18" fill={colors.secondary} />
        </Link>
        <button
          onClick={onDelete}
          className="outline-none border-0 bg-transparent"
        >
          <DeleteIcon
            width="20"
            height="20"
            fill={colors.primary}
            className="ms-2"
          />
        </button>
      </CTableDataCell>
    </CTableRow>
  );
}

export default function TaxiSpecialZonesTable({
  specialZones,
  deleteSpecialZone: deleteCoupon,
  isDeleting,
}: TaxiCouponsTableProps) {
  const [couponToBeDeleted, setCouponToBeDeleted] =
    useState<RideSpecialZone | null>(null);

  useEffect(() => {
    if (!isDeleting) {
      setCouponToBeDeleted(null);
    }
  }, [isDeleting]);

  return (
    <div className="mt-3">
      <CTable>
        <CTableHead>
          <CTableRow>
            <CTableHeaderCell scope="col" className="text-sm">
              <div className="d-flex align-items-center justify-content-between">
                Nom
              </div>
            </CTableHeaderCell>
            <CTableHeaderCell scope="col" className="text-sm ">
              <div className="d-flex align-items-center justify-content-between">
                Prix
              </div>
            </CTableHeaderCell>
            <CTableHeaderCell scope="col" className="text-sm ">
              <div className="d-flex align-items-center justify-content-between">
                Active?
              </div>
            </CTableHeaderCell>
            <CTableHeaderCell scope="col" className="text-sm">
              <div className="d-flex align-items-center justify-content-between">
                Description
              </div>
            </CTableHeaderCell>
            <CTableHeaderCell scope="col" className="text-sm">
              <div className="d-flex align-items-center justify-content-between">
                Actions
              </div>
            </CTableHeaderCell>
          </CTableRow>
        </CTableHead>
        <CTableBody>
          {specialZones?.map((zone) => (
            <TableBodyRowContent
              key={zone.id}
              specialZone={zone}
              onDelete={() => setCouponToBeDeleted(zone)}
            />
          ))}
        </CTableBody>
      </CTable>
      <PromptModal
        open={couponToBeDeleted !== null}
        onAccept={() => deleteCoupon(couponToBeDeleted?.id!)}
        onClose={() => setCouponToBeDeleted(null)}
        loading={isDeleting}
      />
    </div>
  );
}
